<template>
    <div class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Team</div>
                <div class="page-bar-main">{{ onboarding.Name }}</div>
            </div>
            <div style="display:flex;align-items:center" class="hide-mobile-991">
                <div class="btn-light" style="margin-right:15px" @click="$router.back()">Back</div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div v-if="$store.state.user.teamHubRole == 'Admin'" class="page-filters pf-bar">
                <div @click="() => { showSigs = true }" class="add-btn">Signatures</div>
                <div @click="() => { showEdit = true }" class="add-btn">Edit</div>
            </div>
            <div style="display:flex;justify-content:center">
                <div class="playbook" style="padding: 20px 20px 0">
                    <div class="next-nodes" style="display:flex;flex-direction:column;align-items:center">
                        <div v-for="(step, i) in onboarding.StepsJSON" :key="i">
                            <div class="next-node-btn-wrap">
                                <div class="btn" @click="showStepFn(step, i)" :style="userSignOffs[step.id] ? 'background:green;border-color:green' : ''">{{ step.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <add-edit-onboarding v-if="showEdit" :onboardingToEdit="onboarding" @close="() => { getOnboarding(); showEdit = false }" />
        <onboarding-pop-up v-if="showStep" :step="stepToShow" :userSignOffs="userSignOffs" @close="() => { showStep = false; }" @saveSignOffs="saveSignOffs" />
        <onboarding-signatures v-if="showSigs" @close="() => { showSigs = false }" :onboardingProp="onboarding" />
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import OnboardingPopUp from '@/components/OnboardingPopUp.vue';
import AddEditOnboarding from '@/components/AddEditOnboarding.vue';
import OnboardingSignatures from '@/components/OnboardingSignatures.vue';

export default defineComponent({
    name: 'OnboardingsView',
    components: {
        OnboardingPopUp,
        AddEditOnboarding,
        OnboardingSignatures
    },
    data() {
        return {
            onboarding: {} as any,
            userSignOffs: {} as any,
            showStep: false,
            stepToShow: null as any,
            showEdit: false,
            showSigs: false
        }
    },
    async created() {
        await this.getOnboarding();

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async getOnboarding() {
            await axios.get(`${this.$store.state.apiUrl}/api/onboardings/${this.$route.params.id}`)
                .then(resp => {
                    resp.data.StepsJSON = JSON.parse(resp.data.StepsJSON);
                    this.onboarding = resp.data;
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            await axios.get(`${this.$store.state.apiUrl}/api/onboardings/signoffs/${this.$route.params.id}`)
                .then(resp => {
                    this.userSignOffs = JSON.parse(resp.data.SignOffsJSON);
                })
                .catch(e => {
                    console.log(e);
                })
        },
        showStepFn(step: any, index: number) {
            if(this.$store.state.user.teamHubRole != 'Admin') {
                let hasDonePrevious = true;
                if(index > 0) {
                    for(let i = index - 1; i >= 0; i--) {
                        const stepID = this.onboarding.StepsJSON[i].id;
                        if(!this.userSignOffs[stepID]) {
                            hasDonePrevious = false;
                            break;
                        }
                    }
                }
                if(!hasDonePrevious) {
                    alert('Complete the previous steps first');
                    return;
                }
            }
            this.stepToShow = step;
            this.showStep = true;
        },
        async saveSignOffs() {
            const data = {
                onboardingID: this.onboarding.ID,
                userSignOffs: this.userSignOffs
            }
            await axios.post(`${this.$store.state.apiUrl}/api/onboardings/signoffs`, data)
                .catch(e => {
                    console.log(e);
                })
        }
    }
});
</script>
